import { ApplicantTable } from "../components/ApplicantTable";

export const ApplicantsPage = () => {
  return <ApplicantTable />;
};
